import { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { camelCase } from 'lodash-es';

import { ConfigurableCard } from '../../../components/layout/cardElements';
import { NewShipmentForm } from './newShipmentElements';
import { InlineLink } from '../../../components/typography';
import Accordion from '../../../components/layout/Accordion';
import AirRetrievalFlight from '../airRetrieval/AirRetrievalFlight';
import AirRetrievalAirportOrRoute from '../airRetrieval/AirRetrievalAirportOrRoute';
import FlightSummary from '../airRetrieval/components/FlightSummary';
import { useFormContext } from '../../../components/forms/forms';
import AirRetrievalManualEntry from '../airRetrieval/AirRetrievalManualEntry';
import { AIR_RETRIEVAL_MODE } from '../airRetrieval/airRetrieval';
import { useNewShipmentFlightInformationFormStyles } from './NewShipmentFlightInformationForm.styles';
import { useNewShipmentElementsStyles } from './newShipmentElements.styles';

function FlightInformationForm() {
  const { styles } = useNewShipmentElementsStyles();
  const { values, formInstance, forceUpdate } = useFormContext();
  const [activeTab, setActiveTab] = useState(AIR_RETRIEVAL_MODE.MANUAL_ENTRY);
  const [isFlightSelected, setIsFlightSelected] = useState(false);

  const accordionData = useMemo(
    () =>
      [
        {
          mode: AIR_RETRIEVAL_MODE.MANUAL_ENTRY,
          component: AirRetrievalManualEntry,
        },
        {
          mode: AIR_RETRIEVAL_MODE.FLIGHT,
          component: AirRetrievalFlight,
        },
        {
          mode: AIR_RETRIEVAL_MODE.AIRPORT_ROUTE,
          component: AirRetrievalAirportOrRoute,
        },
      ].map(({ mode, component: Component }) => ({
        name: mode,
        titleId: `book.newAirRetrieval.accordion.${camelCase(mode)}`,
        content:
          activeTab === mode ? (
            <Component className={`air-retrieval-${mode}`} isActive />
          ) : null,
      })),
    [activeTab]
  );

  useEffect(() => {
    if (Boolean(values?.flight) && !isFlightSelected) {
      setIsFlightSelected(true);
    }
    // eslint-disable-next-line
  }, [values?.flight]);

  return (
    <>
      <InlineLink
        className={classNames(
          styles.redLink,
          styles.newShipmentLinkAboveFirstSection
        )}
        onClick={() => {
          formInstance.resetFields();
          setIsFlightSelected(false);
          forceUpdate();
        }}
      >
        <FormattedMessage id="buttons.clearForm" />
      </InlineLink>

      {isFlightSelected ? (
        <FlightSummary />
      ) : (
        <div>
          <Accordion
            setValue={setActiveTab}
            value={activeTab}
            data={accordionData}
            collapsibleProps={{
              dynamicContent: true,
            }}
          />
        </div>
      )}
    </>
  );
}

export default function NewShipmentFlightInformationForm({ ...props }) {
  const { styles } = useNewShipmentFlightInformationFormStyles();

  return (
    <NewShipmentForm {...props} preserve name="origin">
      <ConfigurableCard
        titleId="book.newAirRetrieval.fromFlight.title"
        bodyClassName={styles.newShipmentAirRetrieval}
        bodyComponent="div"
      >
        <FlightInformationForm />
      </ConfigurableCard>
    </NewShipmentForm>
  );
}
